import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100%;
  display: flex;
  background-color: #f9f9f9;
  align-items: center;
  justify-content: center;
`;
